function Explore() {
    return (
        <div className="w-96 h-96 absolute right-32 top-80 rounded-full hover:bg-white/[.10] transition duration-300 ease-in">
            <div href="/explore" className="w-64 h-64 rounded-full bg-white m-auto my-16 cursor-pointer">
                <h1 className="text-center text-hover_text font-bellefair py-24">Explore</h1>
            </div>
        </div>
    );
}
export default Explore;